module.exports = __webpack_public_path__ + "static/media/preset_cross_process.5a9308e5.jpg";